document.addEventListener('DOMContentLoaded', function () {
    const input = document.getElementById('medicine-search-input');

    // Check if medicine search elements exist on the page before proceeding
    if (!input) {
        return;
    }

    input.addEventListener('input', function () {
        if (this.value.length < 2) {
            // Clear results if less than 2 characters
            const results = document.getElementById('search-medicine-results');
            if (results) {
                results.innerHTML = '';
            }
        }
    });

    // Override HTMX trigger to only search with 2+ characters
    input.addEventListener('htmx:beforeRequest', function (event) {
        if (this.value.length < 2) {
            event.preventDefault();
            return false;
        }
    });
});